class TomSelectAccessibility {
    constructor(translator) {
        this.translator = translator;
    }

    createRemoveButton() {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'remove';
        button.tabIndex = 0;
        button.textContent = '×';
        return button;
    }

    initialize(instance) {
        instance.hook?.('after', 'setActiveOption', () => this.syncOptions(instance));
        instance.hook?.('after', 'clearActiveOption', () => this.syncOptions(instance));
        this.sync(instance);
    }

    sync(instance) {
        if (instance.input?.multiple) {
            instance.dropdown_content?.setAttribute('aria-multiselectable', 'true');
        }

        this.syncOptions(instance);
        this.syncRemoveButtons(instance);
    }

    syncOptions(instance) {
        const selectedValues = new Set((instance.items ?? []).map((value) => String(value)));
        const options = instance.dropdown_content?.querySelectorAll?.('[role="option"][data-value]') ?? [];

        for (const option of options) {
            option.setAttribute(
                'aria-selected',
                selectedValues.has(String(option.dataset?.value ?? '')) ? 'true' : 'false',
            );
        }
    }

    syncRemoveButtons(instance) {
        const labelField = instance.settings?.labelField ?? 'text';
        const items = instance.control?.querySelectorAll?.('[data-ts-item]') ?? [];

        for (const item of items) {
            const value = String(item.dataset?.value ?? '');
            const option = instance.options?.[value];
            const label = String(option?.[labelField] ?? value);
            const button = item.querySelector?.('button.remove');

            if (!button) continue;

            const accessibleName = this.translator.trans('tomSelect.removeItem', {item: label});
            button.setAttribute('aria-label', accessibleName);
            button.setAttribute('title', accessibleName);
        }
    }
}

export default TomSelectAccessibility;
